import * as React from 'react';
import { useTranslate } from 'react-admin';
import CardWithIcon from './CardWithIcon';

interface Props {
    title: string;
    value?: string;
    icon: React.ElementType;
}

const InfoCard = ({ title, value, icon: Icon }: Props) => {
    return (
        <CardWithIcon
            icon={Icon}
            title={title}
            subtitle={value}
            to={undefined} 
        />
    );
};

export default InfoCard;